const API_BASE_URL = import.meta.env.VITE_API_BASE_URL?.replace(/\/$/, '') ?? ''
const FUNCTIONS_BASE = `${API_BASE_URL}/.netlify/functions`

export const fetchNotificationCounts = async ({ token } = {}) => {
  const response = await fetch(`${FUNCTIONS_BASE}/notifications`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  })
  if (!response.ok) {
    const message = await response.text().catch(() => '')
    throw new Error(message || `Failed to load notifications (${response.status})`)
  }
  const payload = await response.json().catch(() => ({}))
  return payload.data ?? payload
}
